import React from "react";

import keya from "../../assets/images/keya.webp";
import bigm from "../../assets/images/bigm.webp";
import blurise from "../../assets/images/blurise.webp";
import { MdChevronRight } from "react-icons/md";
import { Link } from "react-router-dom";

export default function Project() {
  return (
    <div className="w-full container mx-auto p-3 mt-9 flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <p className="text-[1.125rem] font-semibold text-[#033F6A]">
          Các sản phẩm chính của
        </p>
        <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
          <p className="text-[1.125rem] font-semibold text-white">BlueSkyIT</p>
        </div>
      </div>
      <div>
        <p className="text-[1.5rem] text-[#1375B7] font-semibold lg:text-[2.25rem]">
          Những sản phẩm chính của chúng tôi
        </p>
        <p className="text-[1rem] font-normal text-[#333] lg:w-[66rem]">
          Mỗi sản phẩm của chúng tôi đều hướng tới việc mang lại giá trị thực
          tiễn và hỗ trợ sự phát triển bền vững cho khách hàng.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-4 lg:grid-cols-3 w-full">
        <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2] ">
          <div>
            <img
              src={blurise}
              alt="bl"
              className="w-full h-auto rounded-t-[20px] "
            />
          </div>
          <div className="flex flex-col gap-3 bg-white border border-[#E2E2E2] rounded-b-[20px] px-[30px] py-[16px] relative h-[190px] lg:h-[190px]">
            <p className="text-[24px] font-semibold text-[#0C5393]">
              Hệ thống quản lý giáo dục Blue Rise
            </p>
            <p className="text-[16px] font-normal text-[#333333]">
              Nền tảng quản lý trung tâm giáo dục toàn diện, nâng cao trải
              nghiệm khách hàng
            </p>
            <a href="produ">
              <div className="flex items-center gap-2 text-[#919191] text-[16px] font-normal hover:text-gray-700 absolute bottom-2">
                <p>Xem thêm</p>
                <MdChevronRight />
              </div>
            </a>
          </div>
        </div>
        <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2] ">
          <div>
            <img
              src={bigm}
              alt="big"
              className="w-full h-auto rounded-t-[20px] "
            />
          </div>
          <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] border border-[#E2E2E2] rounded-b-[20px] relative h-[170px] lg:h-[190px]">
            <p className="text-[24px] font-semibold text-[#0C5393]">
              Học viện Bigmax Academy
            </p>
            <p className="text-[16px] font-normal text-[#333333]">
              Đào tạo kỹ năng và nâng cao kiến thức cho thế hệ trẻ với các khóa
              học chuyên sâu.
            </p>
            <a href="produ">
              <div className="flex items-center gap-2 text-[#919191] text-[16px] font-normal hover:text-gray-700 absolute bottom-2">
                <p>Xem thêm</p>
                <MdChevronRight />
              </div>
            </a>
          </div>
        </div>
        <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2] ">
          <div>
            <img
              src={keya}
              alt="keya"
              className="w-full h-auto rounded-t-[20px] "
            />
          </div>
          <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] border border-[#E2E2E2] rounded-b-[20px] h-[170px] lg:h-[190px] relative ">
            <p className="text-[24px] font-semibold text-[#0C5393]">
              Dầu bơ ép lạnh - KeyAvo
            </p>
            <p className="text-[16px] font-normal text-[#333333]">
              Sản phẩm dầu bơ nguyên chất, giàu dinh dưỡng, hỗ trợ sức khỏe toàn
              diện.
            </p>
            <a href="produ">
              <div className="flex items-center gap-2 text-[#919191] text-[16px] font-normal hover:text-gray-700 absolute bottom-2">
                <p>Xem thêm</p>
                <MdChevronRight />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
